import { ObjectMeta } from "@supernova-studio/model";
import { DTOObjectMeta } from "../aux";
import { z } from "zod";
//
// Read
//
export const DTOBrand = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    persistentId: z.string(),
    meta: ObjectMeta,
});
export const DTOBrandGetResponse = z.object({ brand: DTOBrand });
export const DTOBrandCreateResponse = z.object({
    brand: DTOBrand,
});
export const DTOBrandsListResponse = z.object({ brands: z.array(DTOBrand) });
//
// Write
//
export const DTOBrandCreatePayload = z.object({
    persistentId: z.string().uuid(),
    meta: DTOObjectMeta,
});
export const DTOBrandUpdatePayload = z.object({
    meta: DTOObjectMeta.optional(),
    persistentId: z.string(),
});
